/** The envoy dialog's shared classes. */

export const FIELD_LABEL = "text-[14px] font-semibold text-fg";
export const HINT = "text-[12.5px] text-fg-muted";
export const ERROR = "text-[13px] font-medium text-negative";
/** A section's heading: Job preferences, Automation. */
export const SECTION_TITLE =
    "m-0 font-display text-[22px] font-bold leading-tight tracking-[-0.01em] max-[760px]:text-[24px]";
/** Every text box: 16 px on a phone, so the browser does not zoom into it. */
export const TEXT_SIZE = "text-[14px] max-[760px]:text-base";
